export const maximumNumberOfCartOrdersDisplayed = 9;
